import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastService } from 'angular-toastify';
import { ImageFiles, IUploadImage } from '../../models/image-upload.model';
import { ImageUploaderService } from '../../services/image-uploader.service';

@Component({
	selector: 'app-edit-image',
	templateUrl: './edit-image.component.html',
	styleUrls: ['./edit-image.component.scss']
})
export class EditImageDialog implements OnInit {

	public files: ImageFiles[] = [];

	imageExists: boolean = false;
	toVerify: boolean = false;
	imageVerify!: string;

	image!: string;

	constructor(
		public dialogRef: MatDialogRef<EditImageDialog>,
		@Inject(MAT_DIALOG_DATA) public data: string,
		private toastService: ToastService,
		private uploadService: ImageUploaderService,
	) {
		this.image = data;
	}

	ngOnInit(): void {

	}

	changeImage(newValue: string) {
		this.image = newValue;
		this.toVerify = false;
		this.files = [];
		this.imageExists = false;
	}

	verifyImage() {
		this.imageVerify = this.image;
		this.toVerify = true;
	}

	setFile(file: ImageFiles | null) {
		if (file === null) {
			this.image = '';
			this.files = [];
			return;
		}
		this.image = file.name;
		this.files.push(file);
	}

	closeDialog() {
		this.dialogRef.close();
	}

	verifyAndUpload() {
		if (!this.imageExists && this.files.length === 0) {
			this.toastService.error('No image has been selected.')
			return;
		}

		if (this.imageExists) {
			this.dialogRef.close(this.image);
			return;
		}

		if (this.files.length > 0) {
			const uploadFileIds = this.files.map(file => {
				return {
					id: file.name,
					extension: 'jpg',
				} as IUploadImage;
			})

			const fileBlobs = this.files.map(fileInfo => {
				const imageBlob = new Blob([fileInfo.file], {type: `image/jpeg`})
				return imageBlob;
			});

			this.uploadService.uploadImages(fileBlobs, uploadFileIds)
			.subscribe(res => {
				if (!res) {
					this.toastService.error('Failed to upload image');
					return;
				} else {
					this.toastService.success('Image was uploaded successfully');
					this.dialogRef.close(this.files[0].name);
				}
			});
		}
	}

}
